/**
 * Strips C0 control characters that are illegal in XML 1.0.
 * Removes 0x00-0x1F except TAB (0x09), LF (0x0A), CR (0x0D).
 */
export const stripControlChars = (input: string): string => {
  const illegalXmlControlChars = /[\x00-\x08\x0B\x0C\x0E-\x1F]/g;
  return input.replace(illegalXmlControlChars, '');
};
